import api from './api';

export interface ConsentItem {
  consent_type: string;
  version: string;
}

export interface ConsentCheck {
  needs_consent: boolean;
  missing: string[];
}

export interface ConsentResponse {
  id: string;
  user_id: string;
  consent_type: string;
  version: string;
  granted: boolean;
  granted_at: string;
}

export async function checkConsent(): Promise<ConsentCheck> {
  const response = await api.get('/consent/check');
  return response.data;
}

export async function recordConsent(
  consents: ConsentItem[]
): Promise<ConsentResponse[]> {
  const response = await api.post('/consent/', { consents });
  return response.data;
}

export async function getConsentHistory(): Promise<ConsentResponse[]> {
  const response = await api.get('/consent/history');
  return response.data;
}

export async function getRequiredConsents(): Promise<Record<string, string>> {
  const response = await api.get('/consent/required');
  return response.data;
}
